export default "__VITE_ASSET__tZ6cxPxS__"